module.exports = __webpack_public_path__ + "static/media/plus.4031df7e.svg";